import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { DropdownComponent, DropdownModule } from '@usitsdasdesign/dds-ng/dropdown';
import { ICategory } from '../typings';
import { CATEGORIES_THEMES_SETTINGS } from '../constants';
import { Destroy } from '../../../core/destroyClass';
import { takeUntil } from 'rxjs';
import { CategoriesService } from '../categories.service';

@Component({
  selector: 'app-category-dropdown',
  standalone: true,
  imports: [
    DropdownModule
  ],
  templateUrl: './category-dropdown.component.html',
  styleUrl: './category-dropdown.component.scss',
})
export class CategoryDropdownComponent extends Destroy implements OnInit  {
  @Input() category: ICategory;

  @Output() itemSelected = new EventEmitter<{ codeId: string }>();

  @ViewChild('dropdown') dropdown: DropdownComponent;

  get isSelected(): boolean {
    return this.category.path === this.categoriesService.selectedCategory?.path;
  }

  stickerWidth: number;

  constructor(
    private renderer: Renderer2,
    private categoriesService: CategoriesService,
    private cdr: ChangeDetectorRef,
  ) {
    super();
  }

  ngOnInit() {
    this.addThemeStyles();
  }

  ngAfterViewInit() {
    this.dropdown?.sticker.onShown.pipe(takeUntil(this.destroy$)).subscribe(() =>
      this.hideScrollbar(document.body));

    this.dropdown?.sticker.onHidden.pipe(takeUntil(this.destroy$)).subscribe(() =>
      this.revertScrollbar(document.body));

    this.setStickerWidth();
  }

  getStickerWidth(): number {
    return this.dropdown?.dropdownBtn?.nativeElement.getBoundingClientRect().width || 0;
  }

  changeItem(subCategory: any) {
    this.itemSelected.emit({codeId: subCategory.codeId });
  }

  private hideScrollbar(el: HTMLElement) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    el.style.overflow = 'hidden';
    el.style.marginRight = `${scrollbarWidth}px`;
  }

  private revertScrollbar(el: HTMLElement) {
    el.style.overflow = 'auto';
    el.style.marginRight = '0';
  }

  private setStickerWidth(): void {
    this.stickerWidth = this.getStickerWidth();
    this.cdr.detectChanges();
  }

  private addThemeStyles(): void {
    const themeGradient =
      CATEGORIES_THEMES_SETTINGS.find(theme => theme.name === this.category.theme)?.gradient
      || CATEGORIES_THEMES_SETTINGS[0].gradient;
    const style = `
      .category-dropdown_${this.category.theme} .dds-dropdown:before {
        background: linear-gradient(95deg, ${themeGradient[0]} 0%, ${themeGradient[1]} 100%);;
      }
      .category-dropdown-sticker_${this.category.theme} .dds-context-menu:before {
        background: linear-gradient(95deg, ${themeGradient[0]} 0%, ${themeGradient[1]} 100%);;
      }
    `;
    const styleElement = this.renderer.createElement('style');

    this.renderer.appendChild(styleElement, this.renderer.createText(style));
    this.renderer.appendChild(document.head, styleElement);
  }
}
